<template>
  <div class="row">
    <div class="col-12">
      <div class="tile">
        <div class="form-inline">
          <client-select v-if="!client" :model="filterFormModel" attribute="client" :isFilter="true"
                         class="mr-1 mb-1"></client-select>
          <form-select :model="filterFormModel" attribute="status" class="mr-1 mb-1" :options="[
                            {value: null, text: this.$t('allStatus')},
                            {value: '0', text: this.$t('waiting')},
                            {value: '1', text: this.$t('confirmed')},
                            {value: '2', text: this.$t('canceled')},
                            ]"></form-select>
          <form-select :model="filterFormModel" attribute="type" class="mr-1 mb-1" :options="[
                            {value: null, text: this.$t('allTypes')},
                            {value: 'new', text: this.$t('new')},
                            {value: 'user', text: this.$t('user')},
                            {value: 'extend', text: this.$t('extend')},
                            {value: 'trial', text: this.$t('trial')},
                            ]"></form-select>
          <admin-user-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel" attribute="sales"
                             :place-holder="$t('chooseBD')"></admin-user-select>
          <admin-user-select v-if="!client" class="mr-1 mb-1" :model="filterFormModel" attribute="account"
                             :place-holder="$t('chooseAM')"></admin-user-select>
          <time-range-picker :model="filterFormModel" :label="$t('createTime')" class="mr-1 mb-1" :defaultShortcut="3"
                             from-attribute="createTimeFrom" to-attribute="createTimeTo"></time-range-picker>
          <time-range-picker :model="filterFormModel" :label="$t('confirmTime')" class="mr-1 mb-1"
                             from-attribute="confirmTimeFrom" to-attribute="confirmTimeTo"></time-range-picker>
          <time-range-picker :model="filterFormModel" :label="$t('expireTime')" class="mr-1 mb-1"
                             from-attribute="expireTimeFrom" to-attribute="expireTimeTo"></time-range-picker>
          <button @click="load" class="btn btn-primary mr-1 mb-1">{{ $t('search') }}</button>
          <button @click="reset" class="btn btn-secondary mr-1 mb-1">Reset</button>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="c-sorting" v-if="!client">
        <div class="row">
          <div class="col-lg-12 c-sorting__right">
            <div class="c-sorting__btn">
              <buy-new
                  v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
                  :chatbotFee="chatbotFee"></buy-new>
              <buy-user
                  v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
                  :chatbotFee="chatbotFee"></buy-user>
              <extend
                  v-if="['owner', 'admin', 'tech', 'account'].includes($store.state.user.role)"
                  :chatbotFee="chatbotFee"></extend>
              <export :filter="filterFormModel" :total-count="itemCount"
                      v-if="['owner', 'admin', 'tech', 'account', 'accountant'].includes($store.state.user.role)"></export>
            </div>
          </div>
        </div>

      </div>
      <div class="c-paging clearfix">
        <div class="c-paging__count" v-if="itemCount">
          {{ $t('found', [itemCount]) }}
        </div>
        <div class="c-paging__right">
          <div class="c-paging__numbers">
            <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                          v-model="filterFormModel.page" :total-rows="itemCount"
                          :per-page="filterFormModel.pageSize" @input="load"></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12" v-if="items.length">
      <div class="c-smart-table tile">
        <div class="row">
          <div class="col-10">
            <b class="text-info text-right">{{ $t('sum') }}</b>
          </div>
          <div class="col-2">
            <b-spinner v-if="totalLoading" small></b-spinner>
            <span v-else>{{ total | numFormat }}</span></div>
        </div>
        <div class="row c-smart-table__title">
          <div class="col-lg-3" v-if="!client">{{ $t('client') }}</div>
          <div :class="`col-lg-${client ? 4 : 3}`">{{ $t('info') }}</div>
          <div :class="`col-lg-${client ? 2 : 1}`">{{ $t('status') }}</div>
          <div :class="`col-lg-${client ? 4 : 3}`">{{ $t('time') }}</div>
          <div class="col-lg-2">{{ $t('total') }}</div>
        </div>
        <div class="row" v-for="item in items" :key="item._id">
          <div class="col-lg-3" v-if="!client">
            <div>
              <span v-if="!item.client.utm_source" class="badge badge-primary">Tự nhiên</span>
              <span v-else-if="item.client.utm_source && item.client.utm_source === 'sales'"
                    class="badge badge-success">NVKD tự tìm</span>
              <span v-else class="badge badge-warning">Marketing</span>
            </div>
            <div>
              <b>{{ $t('client') }}: </b>
              <span v-if="item.client">{{ item.client.companyName }} ({{ item.client.domain }})</span>
              <span v-else class="text-secondary small">{{ $t('unknown') }}</span>
            </div>
            <div>
              <b>{{ $t('sales') }}: </b>
              <span v-if="item.sales">{{ item.sales.name }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </div>
            <div>
              <b>{{ $t('account') }}: </b>
              <span v-if="item.account">{{ item.account.name }}</span>
              <span v-else class="text-secondary small">{{ $t('notUpdated') }}</span>
            </div>
          </div>
          <div :class="`col-lg-${client ? 4 : 3}`">
            <div><b>{{ $t('type') }}:&nbsp;</b><span>{{ $t(item.type) }}</span></div>
            <div v-if="item.monthCount">
              <b>{{ $t('monthCount') }}:&nbsp;</b>
              <span>{{ item.monthCount }}</span>
            </div>
            <div v-if="item.limit">
              <b>{{ $t('userLimit') }}:&nbsp;</b>
              <span>{{ item.limit }}</span>
            </div>
            <div v-if="item.expireTime">
              <b>{{ $t('expireTime') }}:&nbsp;</b>
              <span>{{ item.expireTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div>
              <b>{{ $t('total') }}:&nbsp;</b>
              <span>{{ item.total | numFormat }}</span>
            </div>
            <div v-if="item.note">
              <b>{{ $t('note') }}:&nbsp;</b>
              <span>{{ item.note }}</span>
            </div>
          </div>
          <div :class="`col-lg-${client ? 2 : 1}`">
            <b class="c-smart-table__label">{{ $t('status') }}: </b>
            <div>
              <label v-if="!item.cancelTime && !item.confirmTime"
                     class="badge badge-warning">{{ $t('waiting') }}</label>
              <label v-if="item.confirmTime" class="badge badge-success">{{ $t('confirmed') }}</label>
              <label v-if="item.cancelTime" class="badge badge-danger">{{ $t('canceled') }}</label>
            </div>
          </div>
          <div :class="`col-lg-${client ? 4 : 3}`">
            <div>
              <b>{{ $t('createTime') }}: </b>
              <span>{{ item.createTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.confirmTime">
              <b>{{ $t('confirmTime') }}: </b>
              <span>{{ item.confirmTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
            <div v-if="item.cancelTime">
              <b>{{ $t('cancelTime') }}: </b>
              <span>{{ item.cancelTime | moment('DD/MM/YYYY HH:mm:ss') }}</span>
            </div>
          </div>
          <div class="col-lg-2">
            <div>
              <span>{{ (item.total ? item.total : 0) | numFormat }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 text-center text-danger" v-if="!items.length">
      <span v-if="filterFormModel.page === 1 && !filterFormModel.keyword">{{ $t('notFoundCreate') }}</span>
      <span v-if="filterFormModel.page > 1 || filterFormModel.keyword">{{ $t('notFoundSearch') }}</span>
    </div>
    <div class="col-12" v-if="itemCount">
      <div class="c-paging__count" v-if="itemCount">
        {{ $t('found', [itemCount]) }}
      </div>
      <b-pagination v-if="itemCount > filterFormModel.pageSize" class="pull-right" size="sm"
                    v-model="filterFormModel.page" :total-rows="itemCount" :per-page="filterFormModel.pageSize"
                    @input="load">
      </b-pagination>
    </div>
  </div>
</template>

<script>
import List from '../../../mixins/List';
import CRUD from "../../../mixins/CRUD";
import ClientSelect from "../../../components/ClientSelect";
import TimeRangePicker from "../../../components/TimeRangePicker";
import BuyNew from "./BuyNew";
import BuyUser from "./BuyUser";
import Extend from "./Extend";
import Export from "./Export";
import _ from 'lodash';
import AdminUserSelect from "@/components/AdminUserSelect";
import moment from 'moment';

export default {
  name: "ClientChatbotList",
  props: ['client'],
  components: {
    AdminUserSelect,
    Extend,
    BuyUser,
    BuyNew,
    ClientSelect,
    TimeRangePicker,
    Export,
  },
  mixins: [List, CRUD],
  data: function () {
    return {
      service: '/client-chatbot',
      autoLoad: true,
      reloadBus: 'clientChatbot',
      defaultFilterFormModel: {
        createTimeFrom: moment(Date.now()).startOf('day').format('x') - 29 * 24 * 60 * 60 * 1000,
        createTimeTo: moment(Date.now()).endOf('day').format('x'),
        confirmTimeFrom: null,
        confirmTimeTo: null,
        department: null,
        group: null,
        client: this.client ? this.client._id : null,
        type: null,
        status: null,
      },
      total: 0,
      totalLoading: true,
      chatbotFee: 0
    }
  },
  methods: {
    search: _.debounce(function () {
      this.filterFormModel.page = 1;
      this.load();
    }, 200),
    load: _.debounce(function () {
      let loader = this.$loading.show();
      this.$service.get(this.service, {
        params: this.filterFormModel
      }).then(response => {
        this.apply(response.data);
        this.sum();
      }).catch(error => {
        if (error.response.data.message) {
          this.$swal({
            text: error.response.data.message,
            icon: 'error'
          });
        }
      }).finally(() => {
        loader.hide();
      });
    }, 200, {leading: true, trailing: false}),
    sum: function () {
      this.totalLoading = true;
      this.$bgService.get(this.service + "/sum", {params: this.filterFormModel}).then(response => {
        this.total = response.data && response.data.length > 0 ? response.data[0].total : 0;
      }).finally(() => {
        this.totalLoading = false
      });
    },
  },
  mounted() {
    this.$bgService.get(this.service + "/chatbot-fee").then(response => {
      this.chatbotFee = response.data ? response.data.chatbotFee : 0;
    })
  },
  i18n: {
    messages: {
      en: {
        waiting: 'Waiting',
        confirmed: 'Confirmed',
        canceled: 'Canceled',
        info: 'Info',
        type: 'Type',
        new: 'New',
        user: 'Buy AI agent',
        upgrade: 'Upgrade',
        extend: 'Extend',
        monthCount: 'Number of month',
        userLimit: 'Number of AI agents',
        expireTime: 'Expire time',
        total: 'Total',
        note: 'Note',
        createTime: 'Create time',
        confirmTime: 'Confirm time',
        buyNew: 'Buy new',
        buyUser: 'Buy user',
        allTypes: 'All types',
        sales: 'Sales',
        account: 'Account',
        noAccount: 'No sales account',
        cancelTime: 'Cancel time',
        chooseBD: 'Select Sales',
        chooseAM: 'Select AM',
        sum: 'Sum',
        group: 'Group',
        department: 'Department',
        companySource: "Company source",
        selfFindingSource: "Self finding source",
        allStatus: "All status",
        trial: "Trial",
      },
      vi: {
        waiting: 'Đợi xác nhận',
        confirmed: 'Đã xác nhận',
        canceled: 'Đã huỷ',
        info: 'Thông tin',
        type: 'Loại',
        new: 'Mua mới',
        user: 'Mua thêm nhân viên AI',
        upgrade: 'Nâng cấp',
        extend: 'Gia hạn',
        monthCount: 'Số tháng',
        userLimit: 'Số nhân viên AI',
        expireTime: 'Thời gian hết hạn',
        total: 'Thành tiền',
        note: 'Ghi chú',
        createTime: 'Thời gian tạo',
        confirmTime: 'Thời gian xác nhận',
        buyNew: 'Mua mới',
        buyUser: 'Mua người dùng',
        allTypes: 'Tất cả các loại',
        sales: 'Sales',
        account: 'Chăm sóc',
        cancelTime: 'Hủy lúc',
        chooseBD: 'Chọn sales',
        chooseAM: 'Chọn chăm sóc',
        sum: 'Tổng',
        group: 'Nhóm',
        department: 'Phòng',
        companySource: "Nguồn công ty",
        selfFindingSource: "Nguồn tự tìm",
        allStatus: "Tất cả trạng thái",
        trial: "Dùng thử",
      }
    }
  }
}
</script>